module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-box text-center"
  }, [_c('p', {
    staticClass: "title text-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('subscription')))]), _vm._v(" "), (_vm.subscriptionInfo.status === 'active' && _vm.subscriptionInfo.payment_method_name !== 'iTunes') ? _c('span', {
    staticClass: "un-subscribe",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#cancel-subscription"
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelSubscription')))]) : _vm._e()]), _vm._v(" "), (_vm.subscriptionInfo.status === 'active') ? [(_vm.subscriptionInfo.payment_method_name === 'iTunes') ? [_c('p', {
    staticClass: "itunes-subscribe"
  }, [_vm._v(_vm._s(_vm.$t('itunesSubscribe')))])] : [_c('p', {
    staticClass: "subscription-package"
  }, [_vm._v(_vm._s(_vm.$t('subscriptionPackage')) + _vm._s(_vm.subscriptionInfo.package_detail.name))]), _vm._v(" "), _c('p', {
    staticClass: "payment-info"
  }, [_vm._v(_vm._s(_vm.$t('paymentMethod')) + _vm._s(_vm.subscriptionInfo.payment_method_name))])]] : _c('p', {
    staticClass: "no-subscription"
  }, [_vm._v(_vm._s(_vm.$t('noSubscription'))), _c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t('goToSubscription')))]), _vm._v(_vm._s(_vm.$t('modalParticle')))], 1), _vm._v(" "), _c('p', {
    staticClass: "declaration"
  }, [_vm._v(_vm._s(_vm.$t('declaration')))]), _vm._v(" "), _vm._l((_vm.$t('declarationList')), function(item, index) {
    return _c('p', {
      staticClass: "declaration-list"
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" " + _vm._s(item))])
  }), _vm._v(" "), _c('cancel-subscription', {
    attrs: {
      "subscriptionInfo": _vm.subscriptionInfo
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b786b3d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/subscription/Index.vue
// module id = 1383
// module chunks = 1